export const data = [
  {
    name: 'Golang',
    src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/go/go-original.svg"
  },
  {
    name: 'C++',
    src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/cplusplus/cplusplus-original.svg"
  },
  {
    name: 'Redis',
    src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/redis/redis-original.svg"
  },
  {
    name: 'Kafka',
    src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/apachekafka/apachekafka-original.svg"
  },
  {
    name: "Ruby",
    src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/ruby/ruby-original.svg"
  },
  {
    name: 'MySQL',
    src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original.svg"
  },
  {
    name: 'AWS',
    src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/amazonwebservices/amazonwebservices-original-wordmark.svg"
  },
  {
    name: "Python",
    src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg"
  },
  {
    name: "Javascript",
    src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg"
  },
  // {
  //   name: 'Django',
  //   src: "https://raw.githubusercontent.com/devicons/devicon/9f4f5cdb393299a81125eb5127929ea7bfe42889/icons/django/django-original.svg"
  // },
  {
    name: 'React',
    src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg"
  },
  {
    name: 'CSS',
    src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-plain.svg"
  },
  {
    name: 'HTML',
    src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-plain.svg"
  },
  // {
  //   name: 'Bootstrap',
  //   src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/bootstrap/bootstrap-plain.svg"
  // }
];